import React, { useLayoutEffect, useRef } from 'react';

import UFOCustomData from '@atlaskit/react-ufo/custom-data';

import { firstChatOpenUFOState } from './firstChatOpenUFOState';

export const FirstChatOpenUFODataPublisher: () => React.JSX.Element = () => {
	const isFirstOpenRef = useRef(!firstChatOpenUFOState.hasOpenedChatInPageSession);

	useLayoutEffect(() => {
		firstChatOpenUFOState.hasOpenedChatInPageSession = true;
	}, []);

	return <UFOCustomData data={{ isFirstChatOpen: isFirstOpenRef.current }} />;
};
